import React from 'react'
import { connect } from 'react-redux'
import { HashLink as Link } from 'react-router-hash-link'
import Title from '../components/Title.jsx'
import Button from '../components/Button.jsx'

const ServicesGridContainer = (props) => {
    const items = props.langData.serviceGrid.map((val, key) => {
        const splittedTitle = val.title.split(' ').map(val => (`${val} `))

        return (
            <div className="col-md-4 grid-col" key={key}>
                <Link to={val.link}>
                    <div className="grid-inner">
                        <img
                            src={`/images/ico/${val.icon}`}
                            className="grid-inner__img"
                        />
                        <h2 className="grid-inner__title">
                            {splittedTitle[0]}<br />{splittedTitle.slice(1)}
                        </h2>
                        <p className="paragraph grid-inner__text hidden-sm hidden-xs">
                            {val.text}
                        </p>
                        <div className="grid-button-container hidden-sm hidden-xs">
                            <img
                                src="/images/ico/bed_arrowgrey.png"
                                className="grid-button-container__button grid-button-container__button--visible"
                            />
                            <img
                                src="/images/ico/bed_arrowwhite.png"
                                className="grid-button-container__button grid-button-container__button--hidden"
                            />
                        </div>
                    </div>
                </Link>
            </div>
        )
    })

    return (
        <div className="section-spacing section-spacing--underbackground" id="usluge">
            <Title
                className="header1--center"
                title={props.langData.serviceTitle}
            />
            <div className="container">
                <div className="row grid-row">
                    {items}
                </div>
                <div className="services-grid-button">
                    <Button
                        link="/usluge"
                        text={props.langData.serviceGridButton}
                        type="yellow"
                    />
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = state => ({
    langData: state.langData.landing
})

export default connect(mapStateToProps)(ServicesGridContainer)



// WEBPACK FOOTER //
// ./src/scripts/containers/ServicesGridContainer.jsx